<template>
  <section class="hero-section">
    <b-carousel id="carousel1" :interval="4000" indicators>
      <b-carousel-slide img-src="img/backgrounds/it-solutions-hardware-banner.png" class="image">
        <div class="col centered-2">
          Providing <b class="red">Digitization</b> and
          <b class="red">Automation</b><br />through Software & Hardware Solutions<br />
          <a href="/#contact-us"><button class="button button-1">DISCOVER MORE</button></a>
        </div>
      </b-carousel-slide>
      <b-carousel-slide img-src="img/backgrounds/ayun-banner.png" class="image">
        <div class="col centered">
          Asset <b class="orange">Tracking</b> App <br />
          <b class="orange">Best</b> for You<br />
          <a href="/#contact-us"><button class="button button-2">REQUEST A DEMO</button></a>
        </div>
      </b-carousel-slide>
      <b-carousel-slide img-src="img/backgrounds/security-solutions-hardware-banner.png" class="image">
        <div class="col centered">
          Hardware <b class="blue">Security</b> <br />
          Solutions<br />
          <a href="/#contact-us"><button class="button button-3">REQUEST A DEMO</button></a>
        </div>
      </b-carousel-slide>
      <b-carousel-slide img-src="img/backgrounds/elog-banner.png" class="image">
        <div class="col centered">
          Digital <b class="green">Logging</b> <br />
          Application<br />
          <a href="/#contact-us"><button class="button button-4">FREE 30-DAY TRIAL</button></a>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </section>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Old+Standard+TT&family=Poppins:wght@800&display=swap");

section {
  background-color: white;
}

.centered {
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 4vw;
  font-weight: 800;
  color: white;
  text-align: center;
  top: -110px;
}

.centered-2 {
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 3.4vw;
  font-weight: 800;
  color: white;
  text-align: center;
  top: -120px;
}

b.red {
  color: #e20818;
  -webkit-text-stroke: 1px white;
}

b.orange {
  color: #e48b10;
  -webkit-text-stroke: 1px white;
}

b.blue {
  color: #004aad;
  -webkit-text-stroke: 1px white;
}

b.green {
  color: #71bb41;
  -webkit-text-stroke: 1px white;
}

.button {
  font-size: 1.5vw;
  font-weight: bold;
  padding-top: 0.5vw;
  padding-bottom: 0.5vw;
  padding-left: 2.5vw;
  padding-right: 2.5vw;
  border-radius: 50px;
  border-style: none;
}

.button-1 {
  color: #e20818;
}

.button-2 {
  color: #e48b10;
}

.button-3 {
  color: #004aad;
}

.button-4 {
  color: #71bb41;
}

@media only screen and (max-width: 939px) and (min-width: 400px) {
  b.red {
    -webkit-text-stroke: 0.5px white;
  }

  .centered {
    top: -50px;
  }

  .centered-2 {
    top: -50px;
  }
}

@media only screen and (max-width: 414px) and (min-width: 100px) {
  .centered {
    top: -20px;
  }

  .centered-2 {
    top: -20px;
  }
}
.hero-section {
  background-color: white;
  position: relative;
  z-index: 0;
}

</style>
